import { Column, Row, Text } from '~/commonComponents';
import { CheckSingleIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';
import CandidateSearchIcon from '~/images/perm/candidate-search-icon.svg';

const tips = [
  {
    title: 'Stronger Candidates From the Start',
    description:
      'Only the right professionals can apply, giving you a curated pool instead of a pile of unqualified resumes.',
  },
  {
    title: 'See How They Work Before You Commit',
    description:
      'Onsite interviews show you their communication, team fit, and workflow in real time so you can hire with confidence.',
  },
  {
    title: 'Keep Your Role Top-of-Mind for Top Talent',
    description:
      'Your job stays live for one month with automatic renewal so professionals keep discovering your role.',
  },
];

export const PermanentJobsTips = () => {
  return (
    <Column
      backgroundColor={Colors.secondary_50}
      borderRadius={8}
      paddingBlock={30}
      paddingInline={35}
    >
      <Text bold color={Colors.primary_500} fontSize={18}>
        Start Receiving Qualified Candidates Today
      </Text>
      <Column gap={14} marginTop={14} marginBottom={26}>
        {tips.map(({ description, title }, i) => (
          <Row gap={3} key={i}>
            <CheckSingleIcon color={Colors.secondary_500} />
            <Column>
              <Text bold>{title}</Text>
              <Text color={Colors.neutral_500}>{description}</Text>
            </Column>
          </Row>
        ))}
      </Column>
      <Row
        alignItems="center"
        backgroundColor="#D1EDF2"
        borderRadius={8}
        gap={15}
        paddingBlock={8}
        paddingInline={12}
      >
        <img src={CandidateSearchIcon} alt="candidate-search-icon" />
        <Column>
          <Text bold color={Colors.primary_500} fontSize={18}>
            The GoTu Difference
          </Text>
          <Text>
            With GoTu, you spend less time searching, more time choosing the right people, and build
            a stronger, more reliable team from day one.
          </Text>
        </Column>
      </Row>
    </Column>
  );
};
